import { type FC } from 'react';

import ExpandableBlock from 'app/components/ExpandableBlock';
import BracketMatch from 'app/components/Blocks/BracketsBlock/BracketMatch';

import style from './style.module.scss';

const NB_MATCHES_DISPLAYED_LIMT = 5;

interface Props {
  title: string;
  matches: TournamentBracketMatch[];
  videogame: VideogameSlug;
  videogameTitle: CounterStrikeVersion | null;
  index: number;
  collapsedByDefault?: boolean;
  selectedTeamId?: number | null;
}

const BracketMatchesListGroup: FC<Props> = ({
  matches,
  title,
  videogame,
  videogameTitle,
  index,
  collapsedByDefault = false,
  selectedTeamId
}) => (
  <ExpandableBlock
    title={title}
    tabIndex={index * 100}
    position="bottom"
    defaultState={collapsedByDefault ? 'closed' : 'opened'}
  >
    <div className={style.matchesListGroup}>
      {matches.slice(0, NB_MATCHES_DISPLAYED_LIMT).map((match, matchIndex) => (
        <BracketMatch
          key={match.id}
          match={match}
          display="compact_without_liaisons"
          videogame={videogame}
          videogameTitle={videogameTitle}
          tabIndex={index * 100 + (matchIndex + 1)}
          selectedTeamId={selectedTeamId}
        />
      ))}
    </div>
  </ExpandableBlock>
);

BracketMatchesListGroup.displayName = 'BracketMatchesListGroup';

export default BracketMatchesListGroup;
